import { FormikInputView } from './formik-input-view';

export const FormikTextView = ({
  name,
  label,
  disabled,
  focused,
  className,
  rows,
  multiline = false,
  formik,
  ...other
}) => (
  <FormikInputView
    className={className}
    label={label}
    name={name}
    disabled={disabled}
    aut
    type={multiline ? 'textarea' : 'text'}
    multiline={multiline}
    rows={rows}
    formik={formik}
    focused={focused}
    {...other}
  />
);
